/**
 * Artist List Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Artist List guide.
 */
export const artistListTourConfig = {
  id: 'artist-list-onboarding',
  storageKey: 'triad_tour_artist_list_completed',
  steps: [
    {
      id: 'artist-add-btn',
      target: '[data-tour="artist-add-btn"], [data-tour="crud-add-btn"]',
      titleKey: 'tour.artistList.addTitle',
      descriptionKey: 'tour.artistList.addDesc',
      position: 'bottom',
      align: 'end'
    },
    {
      id: 'artist-search-input',
      target: '[data-tour="artist-search-input"], [data-tour="crud-search-input"]',
      titleKey: 'tour.artistList.searchTitle',
      descriptionKey: 'tour.artistList.searchDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'artist-table',
      target: '[data-tour="artist-table"], [data-tour="crud-table"]',
      titleKey: 'tour.artistList.tableTitle',
      descriptionKey: 'tour.artistList.tableDesc',
      position: 'top',
      align: 'center'
    }
  ]
};

export default artistListTourConfig;
